import axios from 'axios';

const BASE = '/api/connections';

const connectionService = {

  /**
   * Lista todas as conexões da entidade do usuário logado
   */
  list: async () => {
    const response = await axios.get(BASE);
    return response.data.connections;
  },

  limits: async () => {
    const response = await axios.get(`${BASE}/limits`);
    return response.data.limits || [];
  },

  /**
   * Busca uma conexão pelo ID
   */
  find: async (id) => {
    const response = await axios.get(`${BASE}/${id}`);
    return response.data.connection;
  },

  /**
   * Cria uma nova conexão
   */
  create: async (data) => {
    const response = await axios.post(BASE, data);
    return response.data.connection;
  },

  /**
   * Atualiza uma conexão existente
   */
  update: async (id, data) => {
    const response = await axios.put(`${BASE}/${id}`, data);
    return response.data.connection;
  },

  /**
   * Remove uma conexão
   */
  delete: async (id) => {
    await axios.delete(`${BASE}/${id}`);
  },

  /**
   * Ativa ou desativa uma conexão
   */
  toggle: async (id) => {
    const response = await axios.post(`${BASE}/${id}/toggle`);
    return response.data.connection;
  },

  /**
   * Testa a conexão com o provider
   */
  test: async (id) => {
    const response = await axios.post(`${BASE}/${id}/test`);
    return response.data;
  },

  /**
   * Executa heartbeat manualmente
   */
  heartbeat: async (id) => {
    const response = await axios.post(`${BASE}/${id}/heartbeat`);
    return response.data;
  },

  /**
   * Regenera o token de webhook
   */
  regenerateWebhookToken: async (id) => {
    const response = await axios.post(`${BASE}/${id}/webhook/token`);
    return response.data.token;
  },
  /**
     * Envia uma mensagem de teste pela conexão
     */
    sendMessage: async (id, phone, message) => {
        const response = await axios.post(`${BASE}/${id}/send-message`, {
            phone,
            message
        });
        return response.data;
    },
};

export default connectionService;
